import * as Yup from "yup";
import {
  EMAIL_REGEX,
  PASSWORD_MAX_LIMIT,
  WHITE_SPACES_REGEX,
} from "../constants";
import { getLocalizedMessage } from "../UtilityFunctions/utils";

export const fieldNames = {
  EMAIL: "email",
  PASSWORD: "password",
};

export const initialValues = {
  [fieldNames.EMAIL]: "",
  [fieldNames.PASSWORD]: "",
};

export const loginValidationSchema = (intl) =>
  Yup.object().shape({
    [fieldNames.EMAIL]: Yup.string()
      .required(getLocalizedMessage(intl, "login.fieldError.email.required"))
      .email(getLocalizedMessage(intl, "login.fieldError.email.invalid"))
      .matches(
        EMAIL_REGEX,
        getLocalizedMessage(intl, "login.fieldError.email.invalid")
      )
      .matches(
        WHITE_SPACES_REGEX,
        getLocalizedMessage(intl, "login.fieldError.email.invalid")
      ),
    [fieldNames.PASSWORD]: Yup.string()
      .required(getLocalizedMessage(intl, "login.fieldError.password.required"))
      .max(
        PASSWORD_MAX_LIMIT,
        intl.formatMessage({ id: "login.fieldError.password.max" })
      ),
  });
